'use client';

/**
 * Matrix Plan - Custom Layout
 * All components are specific to this plan only, kept in this folder.
 */

import { PlanIntroSection } from '../common/plan-intro-section';
import { FeaturesSection } from '../common/features-section';
import { WhySoftwareSection } from '../common/why-software-section';
import { HowSoftwareWorksSection } from '../common/how-software-works-section';
import { WhatIsSoftwareSection } from '../common/what-is-software-section';
import { CommissionsSection } from '../common/commissions-section';
import { AdvantagesSection } from './AdvantagesSection';
import { WhatIsPlanSection } from './WhatIsPlanSection';
import { HowItWorksSection } from './HowItWorksSection';
import { Layers, Users, Target, Award } from 'lucide-react';

interface MLMPlan {
    slug: string;
    name: string;
    description: string;
    content: string;
    image?: string;
    features?: string[];
}

interface PlanDetailContentProps {
    plan: MLMPlan;
}

export default function PlanDetailContent({ plan }: PlanDetailContentProps) {
    return (
        <div className="min-h-screen bg-white dark:bg-gray-950">
            <PlanIntroSection
                plan={plan}
                translationNamespace="planDetails.matrixPlan.hero"
                imageSrc="/images/mlm-plans/Matrix_animate.gif"
                descriptionKeys={['description1', 'description2']}
            />
            <WhatIsPlanSection plan={plan} />
            <HowItWorksSection plan={plan} />
            <WhatIsSoftwareSection
                plan={plan}
                translationNamespace="planDetails.matrixPlan.whatIsSoftware"
                imageSrc="/images/mlm-plans/mlm-software-demo.webp"
            />
            <HowSoftwareWorksSection plan={plan} translationNamespace="planDetails.matrixPlan.howSoftwareWorks" />
            <FeaturesSection plan={plan} translationNamespace="planDetails.matrixPlan.features" />
            <AdvantagesSection
                plan={plan}
                translationNamespace="planDetails.matrixPlan.advantages"
                advantageKeys={['advantage1', 'advantage2', 'advantage3', 'advantage4']}
            />
            <CommissionsSection
                plan={plan}
                translationNamespace="planDetails.matrixPlan.commissions"
                commissions={[
                    { icon: Layers, color: 'primary', titleKey: 'level.title', descriptionKey: 'level.description' },
                    { icon: Users, color: 'blue', titleKey: 'matching.title', descriptionKey: 'matching.description' },
                    { icon: Target, color: 'green', titleKey: 'sponsor.title', descriptionKey: 'sponsor.description' },
                    { icon: Award, color: 'purple', titleKey: 'position.title', descriptionKey: 'position.description' },
                ]}
                gridCols="4"
            />
            <WhySoftwareSection plan={plan} translationNamespace="planDetails.matrixPlan.whySoftware" />
        </div>
    );
}

